module.exports = __webpack_public_path__ + "img/handraw_favoris.7a1a1610.svg";